import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { User, VerifiedStatus } from 'anchor-shared/lib/model/entity/user';
import { map } from 'rxjs/operators';
import { CustomerDAO } from '../../../../core/services/dao/customerDAO';
import { Observable } from 'rxjs/Rx';
import { ObservedValueOf } from 'rxjs/internal/types';
import { Customer } from 'anchor-shared/lib/model/entity/customer';
import { AppMessagingService } from '../../../../core/services/app-messaging.service';
import { ContainsSubscriptions } from '../../../../core/services/interfaces/contains-subscriptions';
import { Subscription } from 'rxjs';
import { unsubscribeFromAll } from '../../../../core/pure-functions/rx-helper';
import { UserDAO } from '../../../../core/services/dao/userDAO';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-verify-customer-gov-id',
  templateUrl: './verify-customer-gov-id.component.html',
  styleUrls: ['./verify-customer-gov-id.component.scss'],
})
export class VerifyCustomerGovIdComponent
  implements OnInit, OnDestroy, ContainsSubscriptions
{
  @Input()
  user: User;

  templateData$: Observable<{
    customer: ObservedValueOf<Observable<Customer>>;
  }>;
  subs: Subscription[] = [];
  customer: Customer;
  adminVerified: boolean;
  userVerificationStatus: VerifiedStatus;

  constructor(
    private customerDAO: CustomerDAO,
    private appMessagingService: AppMessagingService,
    private readonly userDAO: UserDAO,
  ) {}

  ngOnInit() {
    this.initAsyncData();
  }

  ngOnDestroy(): void {
    unsubscribeFromAll(this.subs);
  }

  goToStripePaymentIntent(verificationSessionId: string) {
    let stripeUrl = `https://dashboard.stripe.com/identity/verification-sessions/${verificationSessionId}`;
    if (!environment.production) {
      stripeUrl = `https://dashboard.stripe.com/test/identity/verification-sessions/${verificationSessionId}`;
    }
    window.open(stripeUrl, '_blank');
  }

  adminVerifiedChange(): void {
    let userUpdates: Partial<User> = {};
    if (this.adminVerified) {
      userUpdates = {
        verificationSessionId: null,
        verifiedStatus: VerifiedStatus.ADMIN_VERIFIED,
      };
    } else {
      userUpdates = {
        verificationSessionId: null,
        verifiedStatus: VerifiedStatus.REQUIRES_INPUT,
      };
    }
    const userSub = this.userDAO
      .adminUpdateFromPartial(this.user.id, userUpdates)
      .subscribe((user) => {
        this.user.verifiedStatus = user.verifiedStatus;
        this.user.verificationSessionId = user.verificationSessionId;
        this.appMessagingService.openSnack('User verification updated.');
      });
    this.subs.push(userSub);
  }

  saveUserIdVerification(): void {
    const sub = this.customerDAO
      .adminUpdateFromPartial(this.user.id, {
        notes: this.customer.notes,
      })
      .subscribe((data) => {
        this.appMessagingService.openSnack('User notes saved');
      });
    this.subs.push(sub);
  }

  private initAsyncData(): void {
    if (this.user.verifiedStatus === VerifiedStatus.ADMIN_VERIFIED) {
      this.adminVerified = true;
    }
    this.templateData$ = this.customerDAO.adminGetForUser(this.user.id).pipe(
      map((customer) => {
        this.customer = customer;
        return { customer };
      }),
    );
  }
}
